import AnimationComponent from 'Component/Animation';
import TransformComponent from 'Component/Transform';
import Game from 'Game';
import GameObject from 'GameObject/GameObject';
import Armature from 'Prototype/Armature';
import { StartAnimationClip } from 'System/Animation/AnimationHelper';
import { DragonbonesFadeIn } from 'System/Animation/Clip';
import { Random } from 'Utility/Random';

export enum PlinkoTokenLandAnimationClip {
    LEFT = 'land_left',
    RIGHT = 'land_right',
}

export type PlinkoPathValue = -1 | 1;

export function getTokenBounceAnimationName(pathValue: PlinkoPathValue): string {
    if (pathValue === 1) {
        return Random.getRandomItem(['drop_right_1', 'drop_right_2', 'drop_right_3', 'drop_right_4']);
    }

    return Random.getRandomItem(['drop_left_1', 'drop_left_2', 'drop_left_3', 'drop_left_4']);
}

export function getTokenLandAnimationName(pathValue: PlinkoPathValue): PlinkoTokenLandAnimationClip {
    if (pathValue === 1) {
        return PlinkoTokenLandAnimationClip.RIGHT;
    }

    return PlinkoTokenLandAnimationClip.LEFT;
}

export default class PlinkoToken extends GameObject {
    private armature: Armature;
    private glowArmature: Armature;
    private idleGlowTimeout!: () => void;

    public onCreate(params: any) {
        this.addComponent(TransformComponent, params);

        this.armature = GameObject.Instantiate(Armature, {
            name: 'plinko_token',
            dragonbonesName: 'plinko_UI_animations',
            armatureName: 'token',
            animationName: 'static',
            playOnStart: false,
        });
        this.addChild(this.armature);

        this.glowArmature = GameObject.Instantiate(Armature, {
            name: 'plinko_token_glow',
            dragonbonesName: 'plinko_UI_animations',
            armatureName: 'token_glow',
            animationName: 'animation',
            playOnStart: true,
            playTimes: 1,
            alpha: 0,
        });
        this.armature.addChild(this.glowArmature);

        this.playIdleGlowAnimation();
    }

    private readonly playIdleGlowAnimation = () => {
        if (!this.glowArmature) return;

        if (!this.glowArmature.getComponent(AnimationComponent)?.isPlaying) {
            StartAnimationClip(new DragonbonesFadeIn(this.glowArmature, { playTimes: 1 }));
        }

        if (this.idleGlowTimeout) {
            Game.ticker.clearTimeout(this.idleGlowTimeout);
        }

        this.idleGlowTimeout = Game.ticker.setTimeout(this.playIdleGlowAnimation, 3600);
    };

    public getArmature() {
        return this.armature;
    }
}
